import { render, staticRenderFns } from "./TaxBillSales.vue?vue&type=template&id=5cafdec2"
import script from "./TaxBillSales.vue?vue&type=script&lang=js"
export * from "./TaxBillSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports